import axios from "axios";
import {getCookie} from "@/lib/cookie";

/**
 *
 * @param ticketref
 * @param passeggero
 * @returns {Promise<unknown>}
 */
function submitPasseggero(ticketref,passeggero){
    return new Promise((resolve,reject)=> {
        let cookie = getCookie('XSRF-TOKEN');

        let reqobj= {
            ticketref: ticketref,
            nome: passeggero.nome,
            cognome: passeggero.cognome,
            codicefiscale: passeggero.codicefiscale,
            firma: passeggero.firma,
            firmaData: passeggero.firmaData,
            tutor: passeggero.idtutor,
            estero: passeggero.estero
        }

        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_SUBMITPASSEGGERO,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

export { submitPasseggero }